import { render } from "./special-info-box.vue?vue&type=template&id=77e5f00d&scoped=true"
import script from "./special-info-box.vue?vue&type=script&lang=js"
export * from "./special-info-box.vue?vue&type=script&lang=js"

import "./special-info-box.vue?vue&type=style&index=0&id=77e5f00d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e5f00d"]])

export default __exports__